import React from "react";

import TextEditor from "composants/RichTextEditor/TextEditor";

import { STYLES_FOCUSED } from "composants/RichTextEditor/DatatableEditor";
import { tw } from "twind";
import { CustomCellEditorProps } from "ag-grid-react";

export default function CellEditorRichText(props: CustomCellEditorProps) {
  return (
    <div className={tw("bg-gray-100 overflow-scroll h-[200px] p-0")}>
      <TextEditor
        {...props}
        toolbar="TOP"
        onValueChange={(name, value) => {
          props.onValueChange(value);
        }}
        style={STYLES_FOCUSED}
      />
    </div>
  );
}
